const riot = require('riot');

riot.tag2('module-recorder', '<div class="h64 rounded-4 px16 box-shadow {!!activeRecord ? &quot;bg-primary_pale&quot; : &quot;bg-white&quot;}" if="{!app.useragent.isMobile}"> <div class="f fh s-full" show="{isLoading}"> <div class="s32" data-is="atom-indicator"></div> </div> <form class="f fm fbw s-full" show="{!isLoading}" onsubmit="{toggleRecord}"> <input class="w-full py8 bold mr16" ref="title" list="{uniqId}" type="text" placeholder="タスク内容を記入" oninput="{debouncedSearch}" onblur="{onBlur}" onfocus="{onFocus}" readonly="{!!activeRecord}"> <div class="f flex-fixed mr32"> <div class="relative f fm mr16 {!!activeRecord ? &quot;pointer-none&quot; : &quot;cursor-pointer&quot;}"> <div class="absolute t5 l0 pointer-none"><i class="icon-project text-label_medium fs16"></i></div> <select class="fs12 pl20 {&quot;text-label_low&quot; : refs.project.value === &quot;default&quot;}" ref="project" onchange="{selectProject}" value="default"> <option value="default" disabled selected="{selectedProject === &quot;default&quot;}">プロジェクト</option> <option each="{project in opts.projects}" riot-value="{project.id}" selected="{project.id === selectedProject}">{project.data.name}</option> <option value="default">未設定</option> </select> </div> <div class="f fm flex-fixed w200"><i class="icon-tag text-label_medium fs16 mr4"></i> <div class="w-full" ref="tags" data-is="atom-input-tags" readonly="{!!activeRecord}"></div> </div> </div> <div class="text-label_low mr12">{getElapsedTime()}</div> <button class="button primary_pale f fh flex-fixed s36"><i class="fs32 text-primary {!!activeRecord ? &quot;icon-stop&quot; : &quot;icon-start&quot;}"></i></button> </form> </div> <div class="s-full p12" if="{app.useragent.isMobile}"> <div class="s-full p12 rounded-4 box-shadow {!!activeRecord ? &quot;bg-primary_pale&quot; : &quot;bg-white&quot;}"> <div class="f fh s-full" show="{isLoading}"> <div class="s32" data-is="atom-indicator"></div> </div> <form class="f fclm fh s-full" show="{!isLoading}" onsubmit="{toggleRecord}"> <div class="f fm w-full mb12"><i class="icon-edit text-label_medium fs24"></i> <input class="input w-full bold" ref="title" list="{uniqId}" type="text" placeholder="タスク内容を記入" oninput="{debouncedSearch}" onblur="{onBlur}" onfocus="{onFocus}" readonly="{!!activeRecord}"> </div> <div class="relative f fm w-full mb12 {!!activeRecord ? &quot;pointer-none&quot; : &quot;cursor-pointer&quot;}"><i class="icon-project text-label_medium fs24 mr4"></i> <select class="w-full border rounded-8 p8 fs12 {&quot;text-label_low&quot; : refs.project.value === &quot;default&quot;}" ref="project" onchange="{selectProject}" value="default"> <option value="default" disabled selected="{selectedProject === &quot;default&quot;}">プロジェクト</option> <option each="{project in opts.projects}" riot-value="{project.id}" selected="{project.id === selectedProject}">{project.data.name}</option> </select> <div class="absolute t0 b0 r0 h-full f fh px8 pointer-none"><i class="icon-arrow_down"></i></div> </div> <div class="f fm flex-fixed w-full mb12"><i class="icon-tag text-label_medium fs24 mr4"></i> <div class="w-full" ref="tags" data-is="atom-input-tags" readonly="{!!activeRecord}"></div> </div> <button><i class="fs100 text-primary {!!activeRecord ? &quot;icon-stop&quot; : &quot;icon-start&quot;}"></i></button> <div class="fs50 text-label_low">{getElapsedTime()}</div> </form> </div> </div>', 'module-recorder,[data-is="module-recorder"]{display:block}', '', function(opts) {
    this.selectedProject= 'default';
    this.isLoading = true;

    this.setup = (record) => {
      this.activeRecord = record;

      if (this.activeRecord) {
        var project = this.activeRecord.relation.project;

        this.selectedProject = project && project.doc.exists ? project.id : "default";

        if (this.activeRecord.data.title) {
          this.refs.title.value = this.activeRecord.data.title;
        }

        if (this.activeRecord.data.tags.length) {
          this.refs.tags.setValues(this.activeRecord.data.tags);
        }
      }
      this.isLoading = false;
      this.update();
    };

    this.toggleRecord = async (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (!this.activeRecord) {
        var data = {
          title: this.refs.title.value,
          project_ref: this.selectedProject === 'default' ? null : this.selectedProject.ref,
          tags: this.refs.tags.getValues(),
        };

        this.activeRecord = await this.addActiveRecord(data);

        this.trigger('recordingstart', this.activeRecord);
      }
      else {

        if (dayjs(this.activeRecord.data.start_at).isSame(dayjs(), 'minute')) {
          var result = await spat.modal.confirm('レコードを削除しますか？', '時間が短いので保存できません');
          if (!result) return;
          var updatedRecord = this.activeRecord;
          await this.activeRecord.delete();
          this.trigger('recordremove', updatedRecord);
        }
        else {
          await app.store.doc(this.activeRecord.path).update({
            is_recording: false,
            end_at: Date.now(),
            updated_at: Date.now(),
          });
          await app.store.doc(this.activeRecord.path).refresh();
          var updatedRecord = await app.store.doc(this.activeRecord.path).fetch({ relation: true });

          this.trigger('recordingstop', updatedRecord);
        }

        this.refs.title.value = null;
        this.refs.project.value = 'default';
        this.refs.tags.clearValues();
        this.activeRecord = null;
      }

      this.update();
    };

    this.selectProject = () => {
      if (this.activeRecord) return ;
      if (this.refs.project.value !== 'default') {
        this.selectedProject = this.opts.projects.find(p => p.id === this.refs.project.value);
      }
      this.update();
    };

    this.addActiveRecord = async (data) => {
      var ref = await app.store.collection('records').add({
        title: data.title,
        project_ref: data.project_ref,
        tags: data.tags,
        start_at: Date.now(),
        created_at: Date.now(),
        updated_at: Date.now(),
        is_recording: true,
        created_user_ref: app.store.currentUser.ref,
      });
      return await app.store.doc(ref.path).fetch({ relation: true });
    };

    this.startRecorderFromRecord = async (record) => {
      var data = {
        title: record.data.title,
        project_ref: record.relation.project ? record.relation.project.ref : null,
        tags: record.data.tags,
      };

      var active_record = await this.addActiveRecord(data);

      this.trigger('recordingstart', active_record);
      this.setup(active_record);
    };

    this.getElapsedTime = () => {
      if (!this.activeRecord) {
        return '0:00:00';
      }

      var now = new Date();
      var diff = now - this.activeRecord.data.start_at;

      return dayjs.utc(diff).format('H:mm:ss');
    };

    this.debouncedSearch = _.debounce((e) => {
      this.updateSearch(e);
    }, 128);

    this.updateSearch = (e) => {
      var str = e.target.value.toLowerCase();
      if (this.opts.templates) {
        var update_templates = this.opts.templates.filter(item => {
          return item.data.title.toLowerCase().includes(str);
        });
      }

      if (this.opts.recentHistoryRecords) {
        var recent_history_records = this.opts.recentHistoryRecords.filter(item => {
          return item.data.title.toLowerCase().includes(str);
        });
      }

      this.popup.setTemplates(update_templates);
      this.popup.setRecentHistoryRecords(recent_history_records);
    };

    this.onBlur = (e) => {
      setTimeout(() => {
        if (this.popup) {
          this.popup.close();
          this.popup = null;
        }
      }, 256);
    };

    this.onFocus = (e) => {
      if (this.activeRecord) return;
      this.openSuggestionRecorderPopup(e);
      this.updateSearch(e);
    };

    this.openSuggestionRecorderPopup = (e) => {

      e.preventDefault();
      e.stopPropagation();

      this.popup = spat.popup.open('popup-record-list', {
        element: e.currentTarget,

        offsetTop: 0,
        position: 'bottom',
        align: {x: 'left'},
        dismissible: false,
        opts: {
          templates: this.opts.templates,
          recentHistoryRecords: this.opts.recentHistoryRecords
        },
      }).on("select", (item) => {

        if (item.data.title) {
          this.refs.title.value = item.data.title;
        }

        var project = item.relation.project;
        if (project) {

          this.refs.project.value = project.doc.exists ? project.id : "default";
          this.selectProject();
        }
        else {
          this.refs.project.value = "default";
        }

        if (item.data.tags && item.data.tags.length) {
          this.refs.tags.setValues(item.data.tags);
        }
        this.update();
      });
    };
});